import styled from 'styled-components';
import { clsPrefix as cardPrefix } from '../../card.styled';

export const clsPrefix = 'ui-card-header';

export const CardHeaderSC = styled.div`
  display: flex;
  align-items: center;

  padding-top: 16px;
  padding-left: 16px;
  padding-right: 16px;

  .${cardPrefix}-ghost& {
    padding-top: 16px;
    padding-left: 0;
    padding-right: 0;
  }

  .${clsPrefix}-content {
    flex: 1;
  }

  .${clsPrefix}-title {
    ${({ theme }) => theme.mappedTypography.h6.default};
  }

  .${clsPrefix}-description {
    ${({ theme }) => theme.mappedTypography.captionLarge.default};
  }

  .${clsPrefix}-avatar {
    margin-right: 16px;
  }
`;
